import React, { forwardRef, useId } from 'react';

const Input = forwardRef(({
  label,
  error,
  helper,
  leftIcon,
  rightIcon,
  className = '',
  containerClassName = '',
  id,
  ...rest
}, ref) => {
  const autoId = useId();
  const inputId = id || autoId;

  const ringColor = error ? 'focus:ring-danger-200 border-danger-400' : 'focus:ring-primary-200 border-neutral-300 focus:border-primary-500';

  return (
    <div className={`flex flex-col gap-1 ${containerClassName}`}>
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-neutral-700">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400 pointer-events-none">
            {leftIcon}
          </span>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`
            w-full border rounded-md bg-white text-neutral-900 placeholder-neutral-400
            px-3 py-2 text-sm
            ${leftIcon ? 'pl-10' : ''}
            ${rightIcon ? 'pr-10' : ''}
            focus:outline-none focus:ring-4 transition-shadow
            disabled:bg-neutral-100 disabled:text-neutral-500 disabled:cursor-not-allowed
            ${ringColor}
            ${className}
          `}
          {...rest}
        />
        {rightIcon && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400">
            {rightIcon}
          </span>
        )}
      </div>
      {error ? (
        <p className="text-xs text-danger-600">{error}</p>
      ) : helper ? (
        <p className="text-xs text-neutral-500">{helper}</p>
      ) : null}
    </div>
  );
});

Input.displayName = 'Input';
export default Input;
